<template>
  <div>
    <seg-main
      width="100%"
      style="margin-top: 0"
    >
      <template v-slot:title-text>
        <span style="color: #323232;" />
      </template>
      <template v-slot:title-text-en>
        <span style="color: #6e6e6e;" />
      </template>
      <template v-slot:back-word>
        <span style="color:#f6f6f6; font-size: 230px;">PROFESSION</span>
      </template>
      <div style="position: absolute;left: 0; width: 1236px; margin: 0 14%; z-index: 9; top: -160px; display: flex; align-items: center; justify-content: flex-end;">
        <div>
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ name: 'AboutUsExpertTeam'}">
              核心团队
            </el-breadcrumb-item>
            <el-breadcrumb-item>
              专家 - {{ expert.name }}
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </div>
      <div style="position:relative; top: -180px;z-index: 2;display: flex; justify-content: center; align-items: center;">
        <div style="width: 420px;">
          <img
            style="width: 370px"
            :src="expert.pic"
          >
        </div>
        <div style="width: 850px; padding-left: 20px;">
          <h1>{{ expert.name }}</h1>
          <div>
            <h4>{{ expert.title[0] }}</h4>
            <h4>
              {{ expert.title.slice(1).join(' | ') }}
            </h4>
          </div>
          <div v-html="expert.description" />
        </div>
      </div>
    </seg-main>
  </div>
</template>

<script>
import SegMain from '@/components/segPart/segMain';
import {getArticle} from '@/api';
import Expert from '@/components/view/model/expert.js';
export default {
  name: 'ExpertDetail',
  components: {SegMain},
  props: {
    articleId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      expert: {
        name: '',
        title: [],
        pic: '',
        description: ''
      }
    }
  },
  mounted() {
    getArticle({
      id: this.articleId
    }).then(res => {
      this.expert = new Expert(JSON.parse(res.data.data[0].content))
    })
  }
}
</script>

<style scoped>
h4 {
  margin: 6px 0;
}
</style>
